import React from 'react'

//Components
import { LockedIcon, UnlockedIcon} from 'components/SASIcon'

//Styles
import styles from './DownloadContainer.module.scss'

//Types 
import { DownloadChildNode as ChildNodeType } from 'types/download'

//Util
import { convert } from 'util/ByteConverter'

interface Props {
  node: ChildNodeType,
  handleChange: () => void
}

const DownloadChildNode = ({node, handleChange}: Props) => {

  const disabled = node.isSecure && node.isLocked
  
  const toggleNode =( e: React.FormEvent) => {
    if (!disabled) {
      node.isSelected = !node.isSelected
      handleChange()
    }
  }

  return (
    <li className={styles.childNode}>
      <input type="checkbox" id={`${node.alias}_${node.version}`} className={styles.checkbox} checked={node.isSelected} onChange={toggleNode} disabled={node.isSecure && node.isLocked}/>
      <label htmlFor={`${node.alias}_${node.version}`} className={styles.childLabel}>
        <span className={disabled ? styles.disabled : ''}>{node.title}</span>
        {node.fileSize ? ` (${convert(node.fileSize)})` : ''}
        {node.isRecommended ? <b className={styles.recommended}>*</b>: null} 
        {node.isSecure ? node.isLocked ? <LockedIcon/> : <UnlockedIcon/>: null }
      </label>
    </li>
  )
}

export default DownloadChildNode